export default __webpack_public_path__ + "static/media/videoModalThumbnail.17262fbc.PNG";